/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "dcfdd6677d276068fd5f6b27e97f44f00d4bfe61";
